import React from 'react';
import BordPhoto from '../../BordPhoto/BordPhoto';
import { IResponsibleUserData } from '../../../../types/responsibleUser.types';
import './BordResponsibleUserHoverDropdown.scss';

/**
 * Dropdown para mostrar la lista completa de usuarios responsables.
 * @param responsibleUsersList Lista de usuarios responsables a mostrar.
 */
const BordResponsibleUserHoverDropdown: React.FC<BordResponsibleUserHoverDropdownProps> = ({
  responsibleUsersList
}) => {
  const hasMultipleUsers = responsibleUsersList && responsibleUsersList.length > 1;
  const dropdownUserItemStyles = hasMultipleUsers ? 'dropdownUserItem multiple' : 'dropdownUserItem single';

  return (
    <div className="bordResponsibleUserHoverDropdown">
      {responsibleUsersList?.map((user, index) => (
        <div className={dropdownUserItemStyles} key={`${user.id}-${index}`}>
          <BordPhoto
            url={user?.user?.photoProfile}
            variant="circle"
            size="s24"
            avatarProps={{
              variant: 'circularUser',
              standardSize: 24
            }}
          />
          <span className="dropdownUserName truncate">{user?.user?.email}</span>
        </div>
      ))}
    </div>
  );
};

export default BordResponsibleUserHoverDropdown;

export interface BordResponsibleUserHoverDropdownProps {
  responsibleUsersList: IResponsibleUserData[];
}
